module.exports = __webpack_public_path__ + "b87efff09ad1fd0e8da7f17ce94c4a83.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/opensans-npm-webfont/fonts/opensansbold.ttf
// module id = 670
// module chunks = 57